import { useEffect } from 'react'

const ApplyBlurEffect = () => {
    // Find all certificate images and replace them with blurred versions
    const certificateImages = document.querySelectorAll('img[alt="Sertifikat"]')
    certificateImages.forEach((img) => {
        img.style.filter = 'blur(8px)'
        img.style.transition = 'filter 0.3s ease'
    })

    // Create message container
    const messageContainer = document.createElement('div')
    messageContainer.id = 'security-message'
    messageContainer.style.position = 'fixed'
    messageContainer.style.top = '20px'
    messageContainer.style.left = '50%'
    messageContainer.style.transform = 'translateX(-50%)'
    messageContainer.style.backgroundColor = 'rgba(255, 0, 0, 0.8)'
    messageContainer.style.color = 'white'
    messageContainer.style.padding = '10px 20px'
    messageContainer.style.borderRadius = '5px'
    messageContainer.style.zIndex = '10000'
    messageContainer.style.textAlign = 'center'
    messageContainer.style.maxWidth = '90%'
    messageContainer.style.width = 'auto'
    messageContainer.innerHTML = `
        <p style="margin: 0;">
          <strong>Security Alert:</strong> Screenshot attempt detected. Content has been blurred.
        </p>`
    document.body.appendChild(messageContainer)

    // Remove message after 5 seconds
    setTimeout(() => {
        if (messageContainer.parentNode) {
            document.body.removeChild(messageContainer)
        }
    }, 5000)
}

const usePreventScreenshots = () => {
    useEffect(() => {
        let isBlurred = false

        const handleDetection = () => {
            if (!isBlurred) {
                isBlurred = true
                ApplyBlurEffect()
            }
        }

        // Common screenshot detection methods
        const handleKeyDown = (e) => {
            // PrintScreen, Windows Snipping Tool (Win+Shift+S), Mac Screenshot (Cmd+Shift+3/4)
            if (
                e.key === 'PrintScreen' ||
                e.keyCode === 44 ||
                (e.key === 's' && e.shiftKey && (e.metaKey || e.ctrlKey)) ||
                (e.metaKey && e.shiftKey && (e.key === '3' || e.key === '4'))
            ) {
                e.preventDefault()
                handleDetection()
            }
        }

        // Window blur (alt+tab, switching apps)
        const handleBlur = () => {
            handleDetection()
        }

        // Visibility change (tab switching)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                handleDetection()
            }
        }

        // Add event listeners
        document.addEventListener('keydown', handleKeyDown, { capture: true })
        window.addEventListener('blur', handleBlur)
        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            document.removeEventListener('keydown', handleKeyDown, { capture: true })
            window.removeEventListener('blur', handleBlur)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [])
}

export default usePreventScreenshots
